const oldStatus = (statusList, index) => {
  if (statusList[index - 1]) return statusList[index - 1].status
  return '-'
}

const functions = { oldStatus }

export default functions
